require('../styles/main.sass');
require('babel-polyfill');
require('core-js/modules/es7.object.values');
require('core-js/modules/es7.object.entries');
require('root');




// WEBPACK FOOTER //
// ./app/index.js